import axios from "axios";

export default async function printReportSchedule (name, id) {
  const token = localStorage.getItem("token");

  const reportHandlers = {
    scheduling: () => printScheduling(id, token),
  };

  const handler = reportHandlers[name];
  if (!handler) {
    console.log("Invalid report name");
    return null;
  }

  return await handler();
}

async function generateReport (url) {
  try {
    const response = await axios.get(url);

    if (response.status !== 200) {
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Erro ao gerar o relatório:", error);
    return null;
  }
}

async function printScheduling (id, token) {
  const url = `${process.env.VUE_APP_URL_BACKEND}/schedules/print/scheduling/${id}?auth=${token}`;
  return await generateReport(url);
}